export default () => {
  document.querySelectorAll(".js-search-box").forEach((el) => {
    const toggleButton = el.querySelector(".js-search-box-toggle-button");
    const form = el.querySelector(".js-search-box-form");
    const input = form.querySelector("input");
    const dropdown = el.querySelector(".js-search-box-content");

    let timeout = setTimeout(() => {}, 0);

    let expanded =
      toggleButton.getAttribute("aria-expanded") === "true" ? true : false;

    // set state to match button state
    expanded ? open() : close(false);

    bindEvents();

    function bindEvents() {
      toggleButton.addEventListener("click", (e) => {
        e.preventDefault();
        // e.stopPropagation(); // prevent click away from firing

        expanded ? close(true) : open();
      });

      form.addEventListener("keyup", (e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          close(true);
        }
      });
    }

    function open() {
      expanded = true;
      toggleButton.setAttribute("aria-expanded", true);
      el.classList.add("search-box--open");
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        input.focus();
      }, 800);

      document.querySelector("body").addEventListener("click", clickAway);
    }

    function close(focus) {
      expanded = false;
      toggleButton.setAttribute("aria-expanded", false);
      el.classList.remove("search-box--open");
      clearTimeout(timeout);

      if (focus) {
        toggleButton.focus();
      }

      document.querySelector("body").removeEventListener("click", clickAway);
    }

    function clickAway(e) {
      if (!el.contains(e.target) && expanded) {
        close(false);
      }
    }
  });
};
